export default __webpack_public_path__ + "static/media/brainferg0.a97bb34c.jpg";